import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const CHUNK_SIZE = 4 * 1024 * 1024;

export async function uploadInChunks({ declId, file, kind, tipoDoc = '', onProgress }) {
  const uploadId = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  const total = Math.max(1, Math.ceil(file.size / CHUNK_SIZE));
  let result = null;
  for (let i = 0; i < total; i++) {
    const blob = file.slice(i * CHUNK_SIZE, Math.min(file.size, (i + 1) * CHUNK_SIZE));
    const fd = new FormData();
    fd.append('upload_id', uploadId);
    fd.append('index', String(i));
    fd.append('total', String(total));
    fd.append('kind', kind);
    fd.append('filename', file.name);
    fd.append('tipo_doc', tipoDoc);
    fd.append('chunk', blob, `${file.name}.part${i}`);
    const { data } = await axios.post(`${BACKEND_URL}/api/tributario/declaraciones/${declId}/upload/chunk`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: (e) => {
        const done = i * CHUNK_SIZE + (e.loaded || 0);
        onProgress && onProgress(Math.min(99, Math.round((done / file.size) * 100)));
      },
    });
    result = data;
  }
  onProgress && onProgress(100);
  return result;
}

export const formatBytes = (n) => {
  if (!n && n !== 0) return '';
  if (n < 1024) return `${n} B`;
  if (n < 1048576) return `${(n / 1024).toFixed(0)} KB`;
  return `${(n / 1048576).toFixed(1)} MB`;
};

export const formatDateTime = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  return isNaN(d) ? '' : d.toLocaleString('es-CO', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
};

export const MESES = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
export const MES_LABEL = { '01': 'Enero', '02': 'Febrero', '03': 'Marzo', '04': 'Abril', '05': 'Mayo', '06': 'Junio', '07': 'Julio', '08': 'Agosto', '09': 'Septiembre', '10': 'Octubre', '11': 'Noviembre', '12': 'Diciembre' };

export const estadoBadge = (estado) => ({
  Borrador: 'bg-slate-100 text-slate-700 border-slate-200',
  'En elaboración': 'bg-blue-50 text-blue-700 border-blue-200',
  'En revisión': 'bg-amber-50 text-amber-700 border-amber-200',
  Presentada: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  Archivada: 'bg-zinc-100 text-zinc-600 border-zinc-200',
}[estado] || 'bg-slate-100 text-slate-700 border-slate-200');

export const clientDisplayName = (c) => c.razon_social || `${c.primer_nombre || ''} ${c.segundo_nombre || ''} ${c.primer_apellido || ''} ${c.segundo_apellido || ''}`.replace(/\s+/g, ' ').trim();
